import { createFileRoute } from "@tanstack/react-router";
import OrganisationSettingsPage from "src/components/app/OrganisationSettings/OrganisationSettingsPage";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import DocLink from "src/components/docs/DocLink/DocLink";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { organisationLoader } from "src/lib/ScopedLoaders";
import { getOrganisationPageData } from "src/server/functions/Portal";
import { useExtracted } from "#i18n";

export const Route = createFileRoute("/_authed/portal/org_{$orgKey}/settings")({
  loader: organisationLoader((orgId) => getOrganisationPageData({ data: orgId })),
  component: OrganisationSettingsRoute,
});

function OrganisationSettingsRoute() {
  const translateMessage = useExtracted();
  return (
    <PortalPage>
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{translateMessage("Organisation settings")}</PortalPage.Title>
          <PortalPage.Description>
            {translateMessage("The organisation that owns your projects, policies and billing.")}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="organisations" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        <DeferredLoaderData result={Route.useLoaderData()}>
          {(data) => (
            <OrganisationSettingsPage section="settings" initialTeam={data?.initialTeam} />
          )}
        </DeferredLoaderData>
      </PortalPage.Content>
    </PortalPage>
  );
}
